export default {
  districts: [],
  currentDistrict: {
    name: 'carabanchel',
    id: 'carabanchel',
    position: [40.378045, -3.745535],
  },
  collectionsNames: [],
  collectionsList: null,
  currentCollection: 'all',
  searchTerm: '',
  error: false,
  loading: false,
  clickedFeature: null,
  currentCategory: null,
  totalFeatures: 0,
  categories: null,
  categoriesConfig: [],
}
